/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tier } from '../../models/tier';

export interface CreateLoyaltyProgramTier$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
      body: Tier
}

export function createLoyaltyProgramTier(http: HttpClient, rootUrl: string, params: CreateLoyaltyProgramTier$Params, context?: HttpContext): Observable<StrictHttpResponse<Tier>> {
  const rb = new RequestBuilder(rootUrl, createLoyaltyProgramTier.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tier>;
    })
  );
}

createLoyaltyProgramTier.PATH = '/loyalty/programs/{programId}/tiers';
